import React from "react";
import { useNavigate } from "react-router-dom";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import { useSEO } from "../hooks/useSEO";

const NotFound = () => {
  const navigate = useNavigate();
  useSEO(
    "Page Not Found | Mortgage Survival Playbook 2026",
    "The page you're looking for doesn't exist. Return to the Mortgage Survival Playbook institutional early-intervention framework.",
    { noindex: true }
  );
  return (
    <>
      <Nav />
      <div className="legal-wrap" data-testid="notfound-page" style={{ minHeight: "60vh" }}>
        <div className="updated">Error 404</div>
        <h1>This page doesn't exist</h1>
        <p>The link may be out of date or mistyped. Explore the institutional early-intervention framework for mortgage servicers, banks and credit unions from the homepage, or read the latest servicing insights.</p>
        <div style={{ display: "flex", gap: "0.8rem", flexWrap: "wrap", marginTop: "1.5rem" }}>
          <button className="btn-gold" onClick={() => navigate("/")} data-testid="notfound-home-btn" style={{ height: 48, padding: "0 1.6rem" }}>Back to Home</button>
          <button className="admin-btn-ghost" onClick={() => navigate("/insights")} data-testid="notfound-insights-btn">Read Insights</button>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default NotFound;
